export function localeCapitalized(locale: string) {
  return locale.toLocaleUpperCase();
}

export function localizedCategory(category: string, locale: string) {
  if (locale === 'en') {
    return category;
  } else {
    return `${category}-${locale}`;
  }
}
